export const SettingsHeader = ({
  title,
  description,
  marginBottom = 0,
  classes = '',
}: {
  title: string;
  description?: string | React.ReactNode;
  marginBottom?: number;
  classes?: string;
}) => {
  return (
    <div style={{ marginBottom: `${marginBottom}px` }} className={classes}>
      <h2 className="text-2xl font-semibold text-ds-text-darker">{title}</h2>
      <p className="text-ds-text-subtle">{description}</p>
    </div>
  );
};
